import { tryGet, tryPost, tryPut, tryDelete } from './index';

export const getAllFireFlowReports = async () => {
  const result = await tryGet(`/fireFlowReports`);
  return result.data;
}

export const getFireFlowReports = async (hydrantId) => {
  const result = await tryGet(`/fireFlowReports/hydrants/${hydrantId}`);
  return result.data;
};

export const getFireFlowReport = async (fireFlowReportId) => {
  const result = await tryGet(`/fireFlowReports/${fireFlowReportId}`);
  return result.data;
};

export const getFireFlowReportLatest = async (hydrantId) => {
  const result = await tryGet(`/fireFlowReports/latest/${hydrantId}`);
  return result.data;
};

export const getFireFlowReportEdit = async (fireFlowReportId) => {
  const result = await tryGet(`/fireFlowReports/${fireFlowReportId}/edit`);
  return result.data;
};

export const updateFireFlowReport = async (fireFlowReport) => {
  const result = await tryPut(`/fireFlowReports`, fireFlowReport);
  return result.data;
};

export const addFireFlowReport = async (fireFlowReport) => {
  const result = await tryPost(`/fireFlowReports`, fireFlowReport);
  return result.data;
};

export const deleteFireFlowReport = async (fireFlowReportId) => {
  const result = await tryDelete(`/fireFlowReports/${fireFlowReportId}`);
  return result.data;
}